import { createUserWithEmailAndPassword, onAuthStateChanged, sendPasswordResetEmail, signInWithEmailAndPassword, signOut } from "firebase/auth";
import React, { useContext, useEffect, useState } from "react";
import { auth, db } from '../firebase';
import { setDoc, doc } from "firebase/firestore";

const AuthContext = React.createContext();

export function useAuth(){
    return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
    const [ currentUser, setCurrentUser ] = useState();
    const [ loading, setLoading ] = useState(true);

    const signup = async (name, email, password) => {
        if(!name || !email || !password) throw Error("Argumentos inválidos");
        if(email.length>80 || password.length>50) throw Error("Argumentos inválidos");
        if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) || password.length < 6) throw Error("Argumentos inválidos");
        if (!name.trim() || name.trim().length<2 || name.length>50) throw Error("Argumentos inválidos");
        
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email.trim(), password.trim());

            const currentDate = new Date();
            await setDoc(doc(db, "users", userCredential.user.uid), {
                name: name.trim(),
                creationDate: currentDate.getTime(),
                currentWeight: null, weightDaysMap: {},
                height: null,
                dietDaysMap: {}, dietDaysCount: 0,
                trainingDaysMap: {}, trainingDaysCount: 0,
                cardioDaysMap: {}, cardioDaysCount: 0,
                streakCount: 0,
                dietKcal: null, weekTrains: null
            });
        } catch (e) {
            console.log(e)
            throw Error("Erro na criação da collection");
        }
    }

    const login = (email, password) => {
        return signInWithEmailAndPassword(auth, email.trim(), password.trim());
    }

    const logout = () => {
        return signOut(auth);
    }

    const resetPassword = (email) => {
        return sendPasswordResetEmail(auth, email.trim());
    }

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
            setLoading(false);
        })
        return unsubscribe;
    }, [onAuthStateChanged]);

    const value = {
        currentUser,
        signup,
        login,
        logout,
        resetPassword
    }
    return (
        <AuthContext.Provider value={value}>
            { !loading && children }
        </AuthContext.Provider>
    )
}
